import { withBasePath } from '../basePath';

export const CLIENT_LOGOS = [
  { alt: 'Agilit Logo', src: withBasePath('/images/clients/agilit.webp') },
  { alt: 'Alscio Logo', src: withBasePath('/images/clients/alscio.svg') },
  { alt: 'Apollo Logo', src: withBasePath('/images/clients/apollo.webp') },
  { alt: 'Aramis Logo', src: withBasePath('/images/clients/aramis.svg') },
  { alt: 'Archers Logo', src: withBasePath('/images/clients/archers.svg') },
  { alt: 'Archipel Logo', src: withBasePath('/images/clients/archipel.svg') },
  { alt: 'Azarmi Logo', src: withBasePath('/images/clients/azarmiLogo.webp') },
  { alt: 'Baro Logo', src: withBasePath('/images/clients/baroLogo.webp') },
  { alt: 'Betto Logo', src: withBasePath('/images/clients/bettoLogo.webp') },
  { alt: 'Bonifassi Logo', src: withBasePath('/images/clients/bonifassiLogo.webp') },
  { alt: 'Carcreff Logo', src: withBasePath('/images/clients/carcreff.webp') },
  { alt: 'Cazals Manzo Logo', src: withBasePath('/images/clients/cazals-manzo.svg') },
  { alt: 'Desfilis Logo', src: withBasePath('/images/clients/desfilis.svg') },
  { alt: 'Ollyns Logo', src: withBasePath('/images/clients/ollynsLogo.webp') },
  { alt: 'Galm Logo', src: withBasePath('/images/clients/galm.webp') },
  { alt: 'Harlay Logo', src: withBasePath('/images/clients/harlay.webp') },
  { alt: 'Libra Avocats Logo', src: withBasePath('/images/clients/libra-avocats.webp') },
  { alt: 'Moncey Logo', src: withBasePath('/images/clients/moncey.webp') },
  { alt: 'Ooslo Logo', src: withBasePath('/images/clients/ooslo.webp') },
  { alt: 'Oyat Logo', src: withBasePath('/images/clients/oyat.svg') },
  { alt: 'Scottopartners Logo', src: withBasePath('/images/clients/scottopartners.webp') },
  { alt: 'Svz Logo', src: withBasePath('/images/clients/svz.webp') },
  { alt: 'Temime Logo', src: withBasePath('/images/clients/temime.webp') },
  { alt: 'Teynier Logo', src: withBasePath('/images/clients/teynier.webp') },
  { alt: 'Valther Logo', src: withBasePath('/images/clients/valtherLogo.webp') },
  { alt: 'Villechenon Logo', src: withBasePath('/images/clients/villechenon.svg') },
  { alt: 'Vinci Logo', src: withBasePath('/images/clients/vinciLogo.webp') },
  {
    alt: 'Voltaire Avocats',
    src: withBasePath('/images/clients/voltaire-avocats-vertical.svg'),
  },
  { alt: 'Vatier Logo', src: withBasePath('/images/clients/vatierLogo.webp') },
  { alt: 'La Martine Logo', src: withBasePath('/images/clients/laMartineLogo.webp') },
  { alt: 'Flichy Logo', src: withBasePath('/images/clients/flichyLogo.webp') },
  { alt: 'Lombard Logo', src: withBasePath('/images/clients/lombard.webp') },
  { alt: 'Navacelle Logo', src: withBasePath('/images/clients/navacelleLogo.webp') },
];
